<template>
  <div class="alert">
    <h3 :v-if="title">{{title}}</h3>
    <div class="div-link">
      <router-link class="text-link spacing link" :to="route">{{labelLink}}</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "TextLink",
  props: {
    title: {
      type: String
    },
    route: {
      type: String,
      required: true
    },
    "label-link": {
      type: String,
      required: true
    }
  }
};
</script>
<style src="../assets/css/app.css" />